import { FormattedMessage } from 'react-intl'

import { accountPurposeMessages } from '@/constants/messages'
import {
  Select,
  SelectAnimatedPlaceholder,
  SelectContent,
  SelectItem,
  SelectTrigger,
  Typography,
} from '@/shared/ui'

type Props = {
  sources: string[]
  onSelect: (values: string) => void
  placeholder?: string
  value?: string
}

export const AccountPurposeSelectField = ({
  value,
  sources,
  onSelect,
  placeholder,
}: Props) => {
  return (
    <Select onValueChange={onSelect} defaultValue={value}>
      <SelectTrigger>
        <SelectAnimatedPlaceholder
          value={value}
          selectedLabel={
            value && <FormattedMessage {...accountPurposeMessages[value]} />
          }
          placeholder={placeholder}
        />
      </SelectTrigger>

      <SelectContent>
        {sources.map((source) => (
          <SelectItem
            disabled={source === value}
            hideChecked
            className="flex h-[54px]"
            key={source}
            value={source}
          >
            <Typography className="whitespace-break-spaces">
              <FormattedMessage {...accountPurposeMessages[source]} />
            </Typography>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
